import { Component, OnInit } from '@angular/core';

import { ToolbarEvent } from '../../core/events/toolbar.event';
import { FormBuilder, Validators } from '@angular/forms';
import { ContainerComponent } from '../../core/component/Container.Component';
@Component({
	selector: 'app-container',
	templateUrl: 'formcontainer.component.html'
})

export class AppContainerComponent extends ContainerComponent {

	constructor(private toolbarEvent: ToolbarEvent, private fb: FormBuilder) {
		super();
		this.myForm = this.fb.group({});
	}

	async ngOnInit() {
	}
}



// WEBPACK FOOTER //
// ./src/app/shell/formcontainer/formcontainer.component.ts